import { handleDownloadOnClick } from "@_common/downloadfile";
import { formatText } from "@_common/format-text";
import { QueryRequestHelper } from "@_common/query-request-helper";
import CommonImportDataPopup from "@components/BulkUpload/ImportPopup";
import {
  adminImportCheckpoint,
  adminImportDataCheckpoint,
  adminImportLegalUpdate,
} from "@services/checkpoint.service";
import {
  adminImportListManagement,
  adminImportListManagementLegislationRule,
  getTemplates,
} from "@services/list-management.service";
import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

function ImportPopup(props: any) {
  const params = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const { isBulkUploadPopupVisible, setBulkuploadPopupVisibility } = props;
  const [isDataImported, setIsDataImported] = useState(false);
  const [response, setResponse] = useState({});
  const [importType, setImportType] = useState("");
  const [importedFile, setImportTedFile] = useState<any>(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const handleUpload = async () => {
    if (importedFile) {
      try {
        setSubmitLoading(true);
        let formData = new FormData();
        formData.append("file", importedFile);
        let resp;
        if (getValue(props, `type`, "")) {
          let commonFormData = new FormData();
          commonFormData.append("file", importedFile);
          if (getValue(props, `type`, "") !== "CHECKPOINT_MASTER") {
            commonFormData.append("type", getValue(props, `type`, ""));
          }
          //---------------------- Checkpoint ----------------------//
          if (getValue(props, `type`, "") === "CHECKPOINT") {
            resp = await adminImportCheckpoint(commonFormData);
          }
          if (getValue(props, `type`, "") === "CHECKPOINT_MASTER") {
            let payload = {
              domain_name: getValue(params, `domain`, ""),
            };
            let queryRequest = QueryRequestHelper(payload);
            resp = await adminImportDataCheckpoint(
              queryRequest,
              commonFormData
            );
          }

          //---------------------- list management ----------------------//
          if (getValue(props, `type`, "") === "LEGISLATION") {
            resp = await adminImportListManagement(commonFormData);
          }
          if (getValue(props, `type`, "") === "LEGISLATION_RULE") {
            resp = await adminImportListManagementLegislationRule(
              commonFormData
            );
          }
          //---------------------- Legal Update ----------------------//
          if (getValue(props, `type`, "") === "LEGAL_UPDATE") {
            resp = await adminImportLegalUpdate(commonFormData);
          }
        } else {
          toast.error("Something went wrong, Please try after sometime");
        }
        if (resp) {
          setSubmitLoading(false);
          toast.success(getValue(resp, `message`, ""));
          setImportType("");
          setImportTedFile(null);
          importedSuccessfully();
          setResponse(getValue(resp, `data`, {}));
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please Upload File");
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeUpload = async (e: any) => {
    // setImportTedFile(e.target.files[0]);
    setImportTedFile(e[0]);
  };
  const closePopup = () => {
    setBulkuploadPopupVisibility(false);
    setIsDataImported(false);
    setImportTedFile("");
    props.setSelectedOption("");
  };
  const importedSuccessfully = () => {
    setIsDataImported(!isDataImported);
  };
  const handleDownload = async (type: string) => {
    let payload: any = {
      // type: type === "CHECKPOINT_MASTER" ? "CHECKPOINT" : type,
      type: type,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getTemplates(queryRequest);
      if (resp) {
        let URL = getValue(resp, `data[${0}].url`, "");
        let type = getValue(resp, `data[${0}].type`, "");

        if (URL) {
          handleDownloadOnClick(URL, formatText(type));
        }
      }
    } catch (error) {}
    // var link = document.createElement("a");
    // link.target = "_blank";
    // link.download = "Contact";
    // link.href = "url here";
    // link.click();
  };

  return (
    <div>
      {isBulkUploadPopupVisible && (
        <CommonImportDataPopup
          handleUpload={handleUpload}
          handleChangeUpload={handleChangeUpload}
          closePopup={closePopup}
          isDataImported={isDataImported}
          setIsDataImported={setIsDataImported}
          importedSuccessfully={importedSuccessfully}
          importedFile={importedFile}
          setImportTedFile={setImportTedFile}
          response={response}
          handleDownload={handleDownload}
          submitLoading={submitLoading}
          url={props.url}
          type={props.type}
        />
      )}
    </div>
  );
}

export default ImportPopup;
